export const MIN_CANVAS_WIDTH = 240;
export const MAX_CANVAS_WIDTH = 10000;
